export default __webpack_public_path__ + "static/media/Mymy.c699ec9f.jpg";